import { Controller } from "@hotwired/stimulus"
import QrScanner from "qr-scanner"

// Starts the device camera and decodes a QR code, then navigates to the
// lookup URL (this.lookupUrlValue) with the decoded value appended as
// ?token=... — used by the checkin_scan_portal scan screen.
export default class extends Controller {
  static targets = ["video", "error"]
  static values = { lookupUrl: String }

  connect() {
    this.scanner = new QrScanner(
      this.videoTarget,
      (result) => this.handleResult(result),
      { highlightScanRegion: true, highlightCodeOutline: true }
    )

    this.scanner.start().catch((error) => this.showError(error))
  }

  disconnect() {
    this.scanner?.stop()
    this.scanner?.destroy()
  }

  handleResult(result) {
    const token = this.extractToken(result.data)
    if (!token) return

    this.scanner.stop()
    window.location.href = `${this.lookupUrlValue}?token=${encodeURIComponent(token)}`
  }

  // The QR encodes the raw checkin_token; support a full URL being scanned too.
  extractToken(data) {
    try {
      const url = new URL(data)
      return url.searchParams.get("token") || data
    } catch {
      return data
    }
  }

  showError(error) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = error?.message || error
      this.errorTarget.classList.remove("hidden")
    }
  }
}
